/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import axios from 'axios'
import ReactHtmlParser from 'react-html-parser'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import CakeIcon from '@mui/icons-material/Cake'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt'
import HeightIcon from '@mui/icons-material/Height'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import FingerprintIcon from '@mui/icons-material/Fingerprint'
import ChildFriendlyIcon from '@mui/icons-material/ChildFriendly'
import WineBarIcon from '@mui/icons-material/WineBar'
import SmokingRoomsIcon from '@mui/icons-material/SmokingRooms'
import GrassIcon from '@mui/icons-material/Grass'
import ScienceIcon from '@mui/icons-material/Science'
import WorkIcon from '@mui/icons-material/Work'
import SchoolIcon from '@mui/icons-material/School'
import HomeIcon from '@mui/icons-material/Home'
import TempleBuddhistIcon from '@mui/icons-material/TempleBuddhist'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import Brightness3Icon from '@mui/icons-material/Brightness3'
import SearchIcon from '@mui/icons-material/Search'
import TranslateIcon from '@mui/icons-material/Translate'
import NotesIcon from '@mui/icons-material/Notes'

import { viewFeedbackAndVerdictForItemJSX } from '../../../analysisJSX/viewFeedbackAndVerdictForItemJSX'
import { giveElementFeedbackJSX } from '../../../analysisJSX/giveElementFeedbackJSX'

import { positionChangeWidthSm, navbarHeight, footerHeight, bumbleProfileImageWidth, bumbleLeadImageHeight, bumbleImageHeight, bumbleProfileBackgroundColor, bumbleProfileItemBorderColor, bumbleProfileItemDividerOpacity, bumbleProfileItemBoxShadow, bumbleProfileItemBorderWidth, bumbleProfileItemBorderRadius, bumbleProfilePromptTextColor, profPicDefaultURL } from '../../../../../helpers/variableDefaults'
import { inchesToFeetString } from '../../../../../helpers/globalHelpers'


export const viewBumbleVitalInfoLocation = (viewFeedbackTrue, giveFeedbackTrue, isFriendReview, user, datingProfile, width) => {
  
  const showLocations = () => {
    return (
      'vitalInfo' in datingProfile.bio
      && Object.keys(datingProfile.bio.vitalInfo).length > 0
      &&
      (
        ('currentCity' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.currentCity.length > 0 && datingProfile.bio.vitalInfo.currentCity !== 'Prefer not to say')
        || ('hometown' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.hometown.length > 0 && datingProfile.bio.vitalInfo.hometown !== 'Prefer not to say')
      )
    )
  }
  
  return (
    <Box
      sx={{
        mt: viewFeedbackTrue || giveFeedbackTrue ? 2 : 0,
        pt: 2,
        pb: 0,
        backgroundColor: 'white',
        width: bumbleProfileImageWidth(width),
        borderRadius: `0px 0px ${bumbleProfileItemBorderRadius} ${bumbleProfileItemBorderRadius}`,
        // boxShadow: bumbleProfileItemBoxShadow, 
        // border: bumbleProfileItemBorderWidth,
        // borderColor: bumbleProfileItemBorderColor,
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
      }}
    >
      {/* Icon and Title */}
      <Box
        sx={{
          px: 2, 
          pb: 1,
          display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
        }}
      >
        <LocationOnIcon sx={{ mr: .5, width: '15px', height: '15px' }} />

        <Box
          sx={{
            mt: 0,
            // px: 2, 
            // pb: 1,
            fontWeight: 'bold',
            color: 'black',
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
          }}
        >
          My location
        </Box>
      </Box>

      {/* Current City and Hometown */}
      {showLocations() ?
        <Box
          sx={{
            pt: 0, pb: 2, px: 2, 
            // mb: viewFeedbackTrue || giveFeedbackTrue ? 2 : 0,
            display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start',
            flexWrap: 'wrap',
          }}
        >
          {/* Current City */}
          {('currentCity' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.currentCity.length > 0 && datingProfile.bio.vitalInfo.currentCity !== 'Prefer not to say')
            &&
            <Box
              sx={{
                mr: 1, my: 0.5,
                px: 1.5, py: .75,
                // borderColor: bumbleProfileItemBorderColor,
                // border: .01,
                boxShadow: bumbleProfileItemBoxShadow,
                borderRadius: 5,
                backgroundColor: 'whitesmoke',
                fontSize: '14px',
              }}
            >
              {`Lives in ${datingProfile.bio.vitalInfo.currentCity}`}
            </Box>
          }

          {/* Hometown */}
          {('hometown' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.hometown.length > 0 && datingProfile.bio.vitalInfo.hometown !== 'Prefer not to say')
            &&
            <Box
              sx={{
                mr: 1, my: 0.5,
                px: 1.5, py: .75,
                // borderColor: bumbleProfileItemBorderColor,
                // border: .01,
                boxShadow: bumbleProfileItemBoxShadow,
                borderRadius: 5,
                backgroundColor: 'whitesmoke',
                fontSize: '14px',
              }}
            >
              {`From ${datingProfile.bio.vitalInfo.hometown}`}
            </Box>
          }
        </Box>
        :
        <Box
          sx={{
            ml: 1, my: 1,
            px: 1.5, py: .75,
            // borderColor: bumbleProfileItemBorderColor,
            // border: .01,
            boxShadow: bumbleProfileItemBoxShadow,
            borderRadius: 5,
            backgroundColor: 'whitesmoke',
            fontSize: '14px',
          }}
        >
          No Location Given
        </Box>
      }
    </Box>
  )
}

export const viewBumbleVitalInfoItem = (viewFeedbackTrue, giveFeedbackTrue, isFriendReview, user, datingProfile,setProfileReview, width, errors, setErrors, loading, setLoading) => {

  const showMyBio = () => {
    return 'aboutMe' in datingProfile.bio && datingProfile.bio.aboutMe.length > 0 
  }

  const showAboutMe = () => {
    return (
      'vitalInfo' in datingProfile.bio
      && Object.keys(datingProfile.bio.vitalInfo).length > 0
      &&
      (
        (
          ('inOrCmPreference' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.inOrCmPreference.length > 0)
          &&
          (
            ('heightInches' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.heightInches > -1)
            || ('heightCM' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.heightInches > -1)
          )
        )
        ||
        (
          'religion' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.religion.length > 0 && datingProfile.bio.vitalInfo.religion[0].length > 0 && !(datingProfile.bio.vitalInfo.religion.includes('Prefer not to say'))
        )
        ||
        (
          'politics' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.politics.length > 0 && datingProfile.bio.vitalInfo.politics !== 'Prefer not to say'
        )
        ||
        (
          'educationLevel' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.educationLevel.length > 0 && datingProfile.bio.vitalInfo.educationLevel !== 'Prefer not to say'
        )
        ||
        (
          'children' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.children.length > 0 && datingProfile.bio.vitalInfo.children !== 'Prefer not to say'
        )
        ||
        (
          'familyPlans' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.familyPlans.length > 0 && datingProfile.bio.vitalInfo.familyPlans !== 'Prefer not to say'
        )
        ||
        (
          'alcohol' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.alcohol.length > 0 && datingProfile.bio.vitalInfo.alcohol !== 'Prefer not to say'
        )
        ||
        (
          'cigarettes' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.cigarettes.length > 0 && datingProfile.bio.vitalInfo.cigarettes !== 'Prefer not to say'
        )
        ||
        (
          'weed' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.weed.length > 0 && datingProfile.bio.vitalInfo.weed !== 'Prefer not to say'
        )
        ||
        (
          'zodiac' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.zodiac.length > 0 && datingProfile.bio.vitalInfo.zodiac !== 'Prefer not to say'
        )
      )
    )
  }

  const showLanguages = () => {
    return (
      'vitalInfo' in datingProfile.bio
      && Object.keys(datingProfile.bio.vitalInfo).length > 0
      &&
      'languages' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.languages.length > 0 && datingProfile.bio.vitalInfo.languages[0].length > 0 && !(datingProfile.bio.vitalInfo.languages.includes('Prefer not to say'))
    )
  }
  
  const showImLookingFor = () => {
    return (
      'vitalInfo' in datingProfile.bio
      && Object.keys(datingProfile.bio.vitalInfo).length > 0
      &&
      (
        'datingIntentions' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.datingIntentions.length > 0 && datingProfile.bio.vitalInfo.datingIntentions !== 'Prefer not to say'
      )
      ||
      (
        'relationshipType' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.relationshipType.length > 0 && datingProfile.bio.vitalInfo.relationshipType !== 'Prefer not to say'
      )
    )
  }

  const showHobbies = () => {
    return 'hobbies' in datingProfile.bio && datingProfile.bio.hobbies.length > 0 && datingProfile.bio.hobbies.filter(hobby => hobby.length > 0).length > 0
  }

  const vitalInfoItemJSX = (vitalInfoKey, vitalInfoText) => {
    return (
      <Box
        sx={{
          mr: 1, my: 0.5,
          px: 1, py: .5,
          // borderColor: bumbleProfileItemBorderColor,
          // border: .01,
          boxShadow: bumbleProfileItemBoxShadow,
          borderRadius: 5,
          backgroundColor: 'whitesmoke',
          display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
          flexWrap: 'nowrap',
        }}
      >
        {/* Icon */}
        {vitalInfoKey === 'heightInches' || vitalInfoKey === 'heightCM'
          ?
          <HeightIcon sx={{ mr: 0, width: '15px', height: '15px' }} />
          :
          vitalInfoKey === 'religion'
            ?
            <TempleBuddhistIcon sx={{ mr: .5, width: '15px', height: '15px' }} />
            :
            vitalInfoKey === 'politics'
              ?
              <AccountBalanceIcon sx={{ mr: .5, width: '15px', height: '15px' }} />
              :
              vitalInfoKey === 'educationLevel'
                ?
                <SchoolIcon sx={{ mr: .5, width: '15px', height: '15px' }} />
                :
                vitalInfoKey === 'children'
                  ?
                  <ChildFriendlyIcon sx={{ mr: .5, width: '15px', height: '15px' }} />
                  :
                  vitalInfoKey === 'familyPlans'
                    ?
                    <ChildFriendlyIcon sx={{ mr: .5, width: '15px', height: '15px' }} />
                    :
                    vitalInfoKey === 'alcohol'
                      ?
                      <WineBarIcon sx={{ mr: .5, width: '15px', height: '15px' }} />
                      :
                      vitalInfoKey === 'cigarettes'
                        ?
                        <SmokingRoomsIcon sx={{ mr: .5, width: '15px', height: '15px' }} />
                        :
                        vitalInfoKey === 'weed'
                          ?
                          <GrassIcon sx={{ mr: .5, width: '15px', height: '15px' }} />
                          :
                          vitalInfoKey === 'zodiac'
                            ?
                            <Brightness3Icon sx={{ mr: .5, width: '15px', height: '15px' }} />
                            :
                            vitalInfoKey === 'datingIntentions'
                              ?
                              <SearchIcon sx={{ mr: .5, width: '15px', height: '15px' }} />
                              :
                              vitalInfoKey === 'relationshipType'
                                ?
                                <SearchIcon sx={{ mr: .5, width: '15px', height: '15px' }} />
                                :
                                <></>
        }

        {/* Text */}
        <Typography
          sx={{
            // whiteSpace: 'nowrap',
            fontSize: '14px',
          }}
        >
          {`${vitalInfoText}`}
        </Typography>
      </Box>
    )
  } 

  return (
    <Box
      sx={{
        mt: viewFeedbackTrue || giveFeedbackTrue ? 2 : 0,
        py: viewFeedbackTrue || giveFeedbackTrue ? 0 : 2,
        backgroundColor: 'white',
        width: bumbleProfileImageWidth(width),
        // boxShadow: bumbleProfileItemBoxShadow, 
        borderRadius: '0px',
        // border: bumbleProfileItemBorderWidth,
        // borderColor: bumbleProfileItemBorderColor,
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
      }}
    >
      {/* My Bio */}
      {showMyBio() && 
        <>
          <Box
            sx={{
              px: 2, py: 1,
              fontWeight: 'bold',
              color: bumbleProfilePromptTextColor,
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
            }}
          >
            My bio
          </Box>

          <Box
            sx={{
              pt: 0, px: 2,
              pb: ((viewFeedbackTrue || giveFeedbackTrue) && !(showHobbies())) ? 2 : 0,
              fontWeight: 'bold',
              fontSize: '18px',
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
            }}
          >
            {datingProfile.bio.aboutMe}
          </Box>
        </>
      }

      {/* My Interests */}
      {showHobbies() && (viewFeedbackTrue || giveFeedbackTrue) &&
        <>
          <Box
            sx={{
              mt: .5,
              px: 2, py: 1,
              fontWeight: 'bold',
              color: bumbleProfilePromptTextColor,
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
            }}
          >
            My interests
          </Box>
          <Box
            sx={{
              pt: 0, px: 2, 
              pb: ((viewFeedbackTrue || giveFeedbackTrue)) ? 2 : 0,
              display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start',
              flexWrap: 'wrap',
            }}
          >
            {datingProfile.bio.hobbies.filter(hobbyItemToFilter => hobbyItemToFilter.length > 0).map((hobbyItem, hobbyItemIndex) => (
              <Box
                key={hobbyItemIndex}
                sx={{
                  mr: 1, my: 0.5,
                  px: 1.5, py: .75,
                  // borderColor: bumbleProfileItemBorderColor,
                  // border: .01,
                  boxShadow: bumbleProfileItemBoxShadow,
                  borderRadius: 5,
                  backgroundColor: 'whitesmoke',
                  fontSize: '14px',
                }}
              >
                {hobbyItem}
              </Box>
            ))}
          </Box>
        </>
      }

      {/* View Feedback — About Me */}
      {viewFeedbackTrue 
        && (showMyBio() || showMyBio()) 
        && datingProfile.bioFeedback.aboutMeFeedback.feedback.length > 0 
        && datingProfile.bioFeedback.aboutMeFeedback.verdict.length > 0 
        &&
        <Box
          sx={{
            width: bumbleProfileImageWidth(width),
            borderRadius: `0px 0px ${bumbleProfileItemBorderRadius} ${bumbleProfileItemBorderRadius}`,
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
          }}
        >
          {/* Divider */}
          <Divider sx={{ width: '100%', my: 0 }} orientation="horizontal" />

          {/* Feedback and Verdict */}
          {viewFeedbackAndVerdictForItemJSX(datingProfile.bioFeedback.aboutMeFeedback, 'aboutMe', datingProfile.type)}

        </Box>
      }
      
      {/* Give Feedback — About Me  */}
      {giveFeedbackTrue
        && 'mediaFeedback' in datingProfile 
        && datingProfile.mediaFeedback !== null 
        && datingProfile.mediaFeedback.length > 4 
        && 'feedback' in datingProfile.mediaFeedback[4] 
        && 'verdict' in datingProfile.mediaFeedback[4] 
        && 
        giveElementFeedbackJSX(
          'aboutMe', 
          4, 
          isFriendReview,
          datingProfile, 
          setProfileReview, 
          width, 
          errors, 
          setErrors, 
          loading, 
          setLoading
        )
      }

      {/* Margin between About Me and vitalInfo */}
      {(viewFeedbackTrue || giveFeedbackTrue) &&
        <Box
          sx={{
            width: bumbleProfileImageWidth(width),
            height: '17.5px',
            backgroundColor: bumbleProfileBackgroundColor,
          }}
        />
      }

      {/* About Me */}
      {showAboutMe() && 
        <>
          <Box
            sx={{
              // mt: (viewFeedbackTrue || giveFeedbackTrue) ? 2 : .5,
              mt: .5,
              px: 2, py: 1,
              fontWeight: 'bold',
              color: bumbleProfilePromptTextColor,
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
            }}
          >
            About me
          </Box>
          <Box
            sx={{
              pt: 0, px: 2, mb: 0,
              pb: ((viewFeedbackTrue || giveFeedbackTrue) && !showImLookingFor() && !showLanguages() && !(showHobbies() && (viewFeedbackTrue || giveFeedbackTrue))) ? 2 : 0,
              display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start',
              flexWrap: 'wrap',
            }}
          >
            {/* Height */}
            {
              (
                ('inOrCmPreference' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.inOrCmPreference.length > 0)
                &&
                (
                  ('heightInches' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.heightInches > -1)
                  || ('heightCM' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.heightInches > -1)
                )
              )
              &&
              vitalInfoItemJSX(
                (
                  (isFriendReview && datingProfile.bio.vitalInfo.inOrCmPreference === 'cm') 
                  || 
                  (!isFriendReview && user.bio.vitalInfo.inOrCmPreference === 'cm')
                )
                  ?
                  'heightCM'
                  :
                  'heightInches'
                , 
                isFriendReview && datingProfile.bio.vitalInfo.inOrCmPreference === 'cm' 
                  ? 
                  `${datingProfile.bio.vitalInfo.heightCM} cm`
                  :
                  isFriendReview && datingProfile.bio.vitalInfo.inOrCmPreference !== 'cm'
                    ?
                    `${inchesToFeetString(datingProfile.bio.vitalInfo.heightInches)}`
                    :
                    user.bio.vitalInfo.inOrCmPreference === 'cm' 
                      ? 
                      `${datingProfile.bio.vitalInfo.heightCM} cm`
                      :
                      `${inchesToFeetString(datingProfile.bio.vitalInfo.heightInches)}`
                
              )
            }

            {/* Religion */}
            {
              (
                'religion' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.religion.length > 0 && datingProfile.bio.vitalInfo.religion[0].length > 0 && !(datingProfile.bio.vitalInfo.religion.includes('Prefer not to say'))
              )
              &&
              vitalInfoItemJSX(
                'religion',
                datingProfile.bio.vitalInfo.religion[0]
              )
            }

            {/* Politics */}
            {
              (
                'politics' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.politics.length > 0 && datingProfile.bio.vitalInfo.politics !== 'Prefer not to say'
              )
              &&
              vitalInfoItemJSX(
                'politics',
                datingProfile.bio.vitalInfo.politics
              )
            }

            {/* Education Level */}
            {
              (
                'educationLevel' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.educationLevel.length > 0 && datingProfile.bio.vitalInfo.educationLevel !== 'Prefer not to say'
              )
              &&
              vitalInfoItemJSX(
                'educationLevel',
                datingProfile.bio.vitalInfo.educationLevel
              )
            }

            {/* Family Plans */}
            {
              (
                'familyPlans' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.familyPlans.length > 0 && datingProfile.bio.vitalInfo.familyPlans !== 'Prefer not to say'
              )
              &&
              vitalInfoItemJSX(
                'familyPlans',
                datingProfile.bio.vitalInfo.familyPlans
              )
            }

            {/* Children */}
            {
              (
                'children' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.children.length > 0 && datingProfile.bio.vitalInfo.children !== 'Prefer not to say'
              )
              &&
              vitalInfoItemJSX(
                'children',
                datingProfile.bio.vitalInfo.children
              )
            }

            {/* Alcohol */}
            {
              (
                'alcohol' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.alcohol.length > 0 && datingProfile.bio.vitalInfo.alcohol !== 'Prefer not to say'
              )
              &&
              vitalInfoItemJSX(
                'alcohol',
                datingProfile.bio.vitalInfo.alcohol
              )
            }

            {/* Alcohol */}
            {
              (
                'cigarettes' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.cigarettes.length > 0 && datingProfile.bio.vitalInfo.cigarettes !== 'Prefer not to say'
              )
              &&
              vitalInfoItemJSX(
                'cigarettes',
                datingProfile.bio.vitalInfo.cigarettes
              )
            }

            {/* Weed */}
            {
              (
                'weed' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.weed.length > 0 && datingProfile.bio.vitalInfo.weed !== 'Prefer not to say'
              )
              &&
              vitalInfoItemJSX(
                'weed',
                datingProfile.bio.vitalInfo.weed
              )
            }

            {/* Zodiac */}
            {
              (
                'zodiac' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.zodiac.length > 0 && datingProfile.bio.vitalInfo.zodiac !== 'Prefer not to say'
              )
              &&
              vitalInfoItemJSX(
                'zodiac',
                datingProfile.bio.vitalInfo.zodiac
              )
            }
          </Box>
        </>
      }

      {/* Languages */}
      {showLanguages() &&
        <>
          <Box
            sx={{
              mt: .5,
              px: 2, py: 1,
              fontWeight: 'bold',
              color: bumbleProfilePromptTextColor,
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
            }}
          >
            Languages
          </Box>
          <Box
            sx={{
              pt: 0, px: 2, mb: 0,
              pb: (((viewFeedbackTrue || giveFeedbackTrue) && !showImLookingFor()) || (!showHobbies() && !(viewFeedbackTrue || giveFeedbackTrue))) ? 2 : 0,
              display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start',
              flexWrap: 'wrap',
            }}
          >
            {datingProfile.bio.vitalInfo.languages.filter(languageItemToFilter => languageItemToFilter.length > 0).map((languageItem, languageItemIndex) => (
              <Box
                key={languageItemIndex}
                sx={{
                  mr: 1, my: 0.5,
                  px: 1, py: .5,
                  // borderColor: bumbleProfileItemBorderColor,
                  // border: .01,
                  boxShadow: bumbleProfileItemBoxShadow,
                  borderRadius: 5,
                  backgroundColor: 'whitesmoke',
                  fontSize: '14px',
                }}
              >
                {/* Icon */}
                <TranslateIcon sx={{ mr: .5, width: '15px', height: '15px' }} />
                
                {/* Text */}
                <Typography
                  sx={{
                    // whiteSpace: 'nowrap',
                    fontSize: '14px',
                  }}
                >
                  {`${languageItem}`}
                </Typography>
              </Box>
            ))}
          </Box>
        </>
      }


      {/* I'm Looking For */}
      {showImLookingFor() && 
        <>
          <Box
            sx={{
              mt: .5,
              px: 2, py: 1,
              fontWeight: 'bold',
              color: bumbleProfilePromptTextColor,
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
            }}
          >
            {`I'm looking for`}
          </Box>
          <Box
            sx={{
              pt: 0, px: 2, mb: 0,
              pb: ((viewFeedbackTrue || giveFeedbackTrue)) ? 2 : 0,
              display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start',
              flexWrap: 'wrap',
            }}
          >

            {/* Dating Intentions */}
            {
              (
                'datingIntentions' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.datingIntentions.length > 0 && datingProfile.bio.vitalInfo.datingIntentions !== 'Prefer not to say'
              )
              &&
              vitalInfoItemJSX(
                'datingIntentions',
                datingProfile.bio.vitalInfo.datingIntentions
              )
            }

            {/* Relationship Type */}
            {
              (
                'relationshipType' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.relationshipType.length > 0 && datingProfile.bio.vitalInfo.relationshipType !== 'Prefer not to say'
              )
              &&
              vitalInfoItemJSX(
                'relationshipType',
                datingProfile.bio.vitalInfo.relationshipType
              )
            }

          </Box>
        </>
      }

      {/* My Interests */}
      {showHobbies() && !(viewFeedbackTrue || giveFeedbackTrue) &&
        <>
          <Box
            sx={{
              mt: .5,
              px: 2, py: 1,
              fontWeight: 'bold',
              color: bumbleProfilePromptTextColor,
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
            }}
          >
            My interests
          </Box>
          <Box
            sx={{
              pt: 0, px: 2, 
              pb: viewFeedbackTrue || giveFeedbackTrue ? 2 : 0,
              display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start',
              flexWrap: 'wrap',
            }}
          >
            {datingProfile.bio.hobbies.filter(hobbyItemToFilter => hobbyItemToFilter.length > 0).map((hobbyItem, hobbyItemIndex) => (
              <Box
                key={hobbyItemIndex}
                sx={{
                  mr: 1, my: 0.5,
                  px: 1.5, py: .75,
                  // borderColor: bumbleProfileItemBorderColor,
                  // border: .01,
                  boxShadow: bumbleProfileItemBoxShadow,
                  borderRadius: 5,
                  backgroundColor: 'whitesmoke',
                  fontSize: '14px',
                }}
              >
                {hobbyItem}
              </Box>
            ))}
          </Box>
        </>
      }
      

      {/* Feedback — Vital Info */}
      {viewFeedbackTrue && datingProfile.bioFeedback.vitalInfoFeedback.feedback.length > 0 && datingProfile.bioFeedback.vitalInfoFeedback.verdict.length > 0 &&
        <Box
          sx={{
            width: bumbleProfileImageWidth(width),
            borderRadius: `0px 0px ${bumbleProfileItemBorderRadius} ${bumbleProfileItemBorderRadius}`,
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
          }}
        >
          {/* Divider */}
          <Divider sx={{ width: '100%', my: 0 }} orientation="horizontal" />

          {/* Feedback and Verdict */}
          {viewFeedbackAndVerdictForItemJSX(datingProfile.bioFeedback.vitalInfoFeedback, 'vitalInfo', datingProfile.type)}

        </Box>
      }
    </Box>
  )
}